import { RestService } from './ResyService';
import { AssociatePlant, Customer } from '@/models';
import { CustomerEndPoints } from './config';

export class CustomerService extends RestService {


    associateCustomer(data: AssociatePlant) {
        const body = JSON.stringify({
            "plant_id": data.plant_id,
            "customer_id": data.customer_id,
        })
        return this.post(CustomerEndPoints.associatePlant, body);
    }

    addCustomer(data: Customer) {
        const body = JSON.stringify({
            'name': data.name,
            'address': data.address,
            'phone_no': data.phone_no,
            'phone_code': data.phone_code,
            'login_ids': data.login_ids
        })
        return this.post(CustomerEndPoints.AddCustomer, body);
    }

    getAllCustomer() {
        return this.get(CustomerEndPoints.customers);
    }
    getAllUsers() {
        return this.get(CustomerEndPoints.Users);
    }

}